// src/App.jsx
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

const LandingPage = lazy(() => import('./pages/LandingPage'));
const CollectionPage = lazy(() => import('./pages/CollectionPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const SignupPage = lazy(() => import('./pages/SignupPage'));
const ProductPage = lazy(() => import('./pages/ProductPage'));
const ShoppingBagPage = lazy(() => import('./pages/ShoppingBagPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const OrderSummaryPage = lazy(() => import('./pages/OrderSummaryPage'));
const AccountDashboard = lazy(() => import('./pages/AccountDashboard'));
const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const ProductCollectionPage = lazy(() => import('./pages/ProductCollectionPage'));
const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess'));
const PaymentCancel = lazy(() => import('./pages/PaymentCancel'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsOfUsePage = lazy(() => import('./pages/TermsOfUsePage'));
const FAQPage = lazy(() => import('./pages/FAQPage'));

// A simple loading fallback
const PageLoader = () => (
    <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
    </div>
);

// ---- Child component lives INSIDE the Router, so useLocation() is safe here
function AppRoutes() {
  const location = useLocation();

  return (
      <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />

            {/* Categories */}
            <Route path="/category/:slug" element={<CollectionPage key={location.pathname} />} />

            {/* Collections */}
            <Route path="/collections/:slug" element={<ProductCollectionPage key={location.pathname} />} />

            {/* Products */}
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/products" element={<ProductsPage />} />

            {/* Static pages */}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/shopping-bag" element={<ShoppingBagPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order-summary" element={<OrderSummaryPage />} />
            <Route path="/account-dashboard" element={<AccountDashboard />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-use" element={<TermsOfUsePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/shipping-delivery" element={<FAQPage />} />
            <Route path="/order-status" element={<FAQPage />} />
            <Route path="/returns-exchange" element={<FAQPage />} />
            <Route path="/ordering-payments" element={<FAQPage />} />
          </Routes>
      </Suspense>
  );
}

export default function App() {
  return (
      <Router>
        <AppRoutes />
      </Router>
  );
}
